/* vl-product-carousel: arrow-driven scroll-snap track. */
(function () {
  'use strict';
  class VlCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vl-pcar__track');
      this.prev = this.querySelector('.vl-pcar__arrow--prev');
      this.next = this.querySelector('.vl-pcar__arrow--next');
      if (!this.track) return;
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.paint(), { passive: true });
      this.paint();
    }
    step(dir) {
      const item = this.track.querySelector('.vl-pcar__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '16') || 16;
      this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
    }
    paint() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      if (this.next) this.next.toggleAttribute('disabled', this.track.scrollLeft >= max);
    }
  }
  if (!customElements.get('vl-carousel')) customElements.define('vl-carousel', VlCarousel);
})();
